import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { CookieConsent } from '@/components/CookieConsent';
import { NewsScreen } from '@/screens/NewsScreen';
import ArticleDetailScreen from '@/screens/ArticleDetailScreen';
import { ImpressumScreen } from '@/screens/ImpressumScreen';
import { DatenschutzScreen } from '@/screens/DatenschutzScreen';
import { HomeScreen } from '@/screens/HomeScreen';
import { PlayerScreen } from '@/screens/PlayerScreen';
import { ExploreScreen } from '@/screens/ExploreScreen';
import { FavoritesScreen } from '@/screens/FavoritesScreen';
import { SettingsScreen } from '@/screens/SettingsScreen';
import { LiveVideoScreen } from '@/screens/LiveVideoScreen';
import { useZenoMetadata } from '@/hooks/useZenoMetadata';
import { useAzuraCastMetadata } from '@/hooks/useAzuraCastMetadata';
import { useNativeBridge } from '@/hooks/useNativeBridge';
import { useAudioStore } from '@/hooks/useAudioStore';
import { isMobileApp, mobileBridge } from '@/utils/mobileBridge';
import { applyStoredConsent } from '@/utils/consent';

function App() {
  useZenoMetadata();
  useAzuraCastMetadata();
  useNativeBridge();

  // GDPR Consent Mode v2 — propagiraj persistirani consent u gtag PRIJE
  // 500ms wait_for_update window-a (postavljen u index.html). Bez ovoga, vraćeni
  // korisnik koji je ranije pristao opet ne bi bio tracked do prvog accept klika.
  useEffect(() => {
    applyStoredConsent();
  }, []);

  // Forward currentTrack updates to native mobile WebView (lock screen artwork/metadata).
  // U PWA mod-u ovo je NoOp jer isMobileApp() vraća false.
  useEffect(() => {
    if (!isMobileApp()) return;
    const unsub = useAudioStore.subscribe((state, prev) => {
      const ct = state.currentTrack;
      const pt = prev.currentTrack;
      if (!ct) return;
      if (pt && pt.title === ct.title && pt.artist === ct.artist && pt.artwork === ct.artwork) {
        return;
      }
      mobileBridge.trackUpdate({
        artist: ct.artist,
        title: ct.title,
        artwork: ct.artwork,
      });
    });
    return unsub;
  }, []);

  return (
    <>
    <Layout>
      <Routes>
        <Route path="/" element={<NewsScreen />} />
        <Route path="/article/:slug" element={<ArticleDetailScreen type="article" />} />
        {/* Legacy alias — /news/:slug ide kroz Article fallback chain (TASK 23b) */}
        <Route path="/news/:slug" element={<ArticleDetailScreen type="article" />} />
        {/* TASK 31: /program/:slug ide direktno u Programs kolekciju (mirror Article-a) */}
        <Route path="/program/:slug" element={<ArticleDetailScreen type="program" />} />
        <Route path="/impressum" element={<ImpressumScreen />} />
        <Route path="/datenschutz" element={<DatenschutzScreen />} />
        <Route path="/app" element={<HomeScreen />} />
        <Route path="/app/player" element={<PlayerScreen />} />
        <Route path="/app/explore" element={<ExploreScreen />} />
        <Route path="/app/favorites" element={<FavoritesScreen />} />
        <Route path="/app/settings" element={<SettingsScreen />} />
        <Route path="/app/live-video" element={<LiveVideoScreen />} />
      </Routes>
    </Layout>
    <CookieConsent />
    </>
  );
}

export default App;
